"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateFormatter = exports.parseNewDate = exports.formatDateWithAppend = exports.appendSeparator = exports.determineSeparatorIndexes = exports.determineSeparator = void 0;
var rifm_1 = require("rifm");
var react_1 = require("react");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("./translations"));
var usePrevious_1 = require("./usePrevious");
var determineSeparator = function (format) {
    var _a;
    return ((_a = format.match(/\W/)) === null || _a === void 0 ? void 0 : _a[0]) || '/';
};
exports.determineSeparator = determineSeparator;
var determineSeparatorIndexes = function (format, isFirstSeparatorRemoved) {
    var separatorIndexes = [];
    var separator = (0, exports.determineSeparator)(format);
    format.split('').forEach(function (char, index) {
        if (separator === char) {
            separatorIndexes.push(index);
        }
    });
    return [separatorIndexes[0], isFirstSeparatorRemoved ? separatorIndexes[1] - 1 : separatorIndexes[1]];
};
exports.determineSeparatorIndexes = determineSeparatorIndexes;
/**
 * Appends the separator while typing new characters
 */
var appendSeparator = function (value, format) {
    var separatorIndexes = (0, exports.determineSeparatorIndexes)(format);
    return separatorIndexes.includes(value.length) ? value + (0, exports.determineSeparator)(format) : value;
};
exports.appendSeparator = appendSeparator;
/**
 * Adjusts the separator position after digits have been edited
 */
var formatDateWithAppend = function (dateString, format) {
    // remove separators
    var digitsArray = (dateString.match(/\d+/g) || []).join('').split('');
    var separator = (0, exports.determineSeparator)(format);
    // Add the in-between separators back in; i.e. 0205 becomes 02/05
    var stringWithInterimSeparators = digitsArray
        .reduce(function (r, v, index) { return ((0, exports.determineSeparatorIndexes)(format, true).includes(index) ? "".concat(r).concat(separator).concat(v) : "".concat(r).concat(v)); }, '')
        .slice(0, 10);
    // Now readd the last separator if needed
    return dateString.endsWith(separator) ? "".concat(stringWithInterimSeparators).concat(separator) : stringWithInterimSeparators;
};
exports.formatDateWithAppend = formatDateWithAppend;
var parseNewDate = function (textValue, date, parseDate, onChange, onError, formatMessage) {
    if (textValue.length === 10) {
        var newDate = parseDate(textValue);
        if (newDate && newDate.getTime() !== (date === null || date === void 0 ? void 0 : date.getTime())) {
            var isDateValid = newDate instanceof Date && !isNaN(newDate.getTime());
            if (!isDateValid) {
                onError(formatMessage(messages, 'invalidDate'));
                return;
            }
            else {
                onChange(newDate);
            }
        }
    }
    onError();
};
exports.parseNewDate = parseNewDate;
var useDateFormatter = function (_a) {
    var value = _a.value, onChange = _a.onChange, onError = _a.onError;
    var _b = (0, design_system_foundations_1.useLocalizationContext)(), formatDate = _b.formatDate, parseDate = _b.parseDate, getDatePlaceholder = _b.getDatePlaceholder, formatMessage = _b.formatMessage;
    var _c = (0, react_1.useState)(value ? formatDate(value) || '' : ''), textValue = _c[0], setTextValue = _c[1];
    var previousDate = (0, usePrevious_1.usePrevious)(value);
    var format = getDatePlaceholder();
    (0, react_1.useEffect)(function () {
        var dateFormat = format; // NOSONAR https://github.com/SonarSource/SonarJS/issues/1961
        // update text if date changed from outside
        if ((value === null || value === void 0 ? void 0 : value.getTime()) !== (previousDate === null || previousDate === void 0 ? void 0 : previousDate.getTime())) {
            if (!value && textValue) {
                // date is cleared
                setTextValue('');
            }
            else if (value && formatDate(value, dateFormat) !== textValue) {
                // new date
                setTextValue(formatDate(value, dateFormat) || '');
            }
        }
    }, [value, previousDate, textValue, formatDate, format]);
    var _d = (0, rifm_1.useRifm)({
        append: function (newValue) { return (0, exports.appendSeparator)(newValue, format); },
        value: textValue,
        format: function (unformattedDate) { return (0, exports.formatDateWithAppend)(unformattedDate, format); },
        onChange: function (newTextValue) {
            setTextValue(newTextValue);
            (0, exports.parseNewDate)(newTextValue, value, parseDate, onChange, onError, formatMessage);
        },
        mask: 10 <= textValue.length,
    }), onInputChange = _d.onChange, inputValue = _d.value, defaultRifmProps = __rest(_d, ["onChange", "value"]);
    return __assign(__assign({}, defaultRifmProps), { inputValue: inputValue, onInputChange: onInputChange });
};
exports.useDateFormatter = useDateFormatter;
